import { render, staticRenderFns } from "./IframeSettingsModal.vue?vue&type=template&id=1a587622"
import script from "./IframeSettingsModal.vue?vue&type=script&lang=js"
export * from "./IframeSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./IframeSettingsModal.vue?vue&type=style&index=0&id=1a587622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports